export default function () {
  return (-this.snapGrid[0]);
}



// WEBPACK FOOTER //
// ./node_modules/framework7/components/swiper/swiper-class/components/core/translate/minTranslate.js